import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6bb8b64a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/meiyeJinHuo/meiyeJinHuoAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb8b64a')) {
      api.createRecord('6bb8b64a', component.options)
    } else {
      api.reload('6bb8b64a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6bb8b64a&", function () {
      api.rerender('6bb8b64a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/header-aside/components/header-system-select/index.vue"
export default component.exports